import React, { Fragment, useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import FormView from "./FormView";
import { showDialog } from "../../appRedux/actions/common";
import { setMentorInfo } from "../../appRedux/actions/mentors";
import DialogModal from "../Common/DialogModal";

function EditInfo({ info }) {
  const dispatch = useDispatch();
  const [open, setOpen] = useState(false);
  const { dialog } = useSelector((state) => ({
    dialog: state.common.dialog,
  }));

  useEffect(() => {
    if (!dialog) {
      setOpen(false);
    }
  }, [dialog]);

  const handleEdit = () => {
    setOpen(true);
    dispatch(setMentorInfo(info));
    dispatch(
      showDialog({
        title: `Edit Mentor: ${info.displayName || info.name}`,
        size: "xl",
        id: info._id,
      })
    );
  };

  return (
    <Fragment>
      <button
        type="button"
        className="dropdown-item"
        onClick={handleEdit}
        key={`edit_mentor_${info._id}`}
      >
        <i className="fa fa-pencil m-r-5" /> Edit Profile
      </button>
      {open && (
        <DialogModal
          infoId={info._id}
          key={`modal_${info._id}`}
          bodyView={<FormView isUpdate={true} key={`form_${info._id}`} />}
        />
      )}
    </Fragment>
  );
}

export default EditInfo;
